import { FileResultDto } from '@higo/api/lib/models/fileResultDTO';
import { indexBy, prop } from 'rambda';

export const indexAuscultationResultsByPointer = (list: FileResultDto[]) =>
  indexBy(prop('pointer'), list);
